import { useContext } from "react";
import { UserDataContext } from "../routes/Main";

export default function isCustomer() {
    const { userData } = useContext(UserDataContext);
    return (
        userData?.data?.roles[0]?.name === 'cus'
            ? true
            : false
    )
}
